"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemNotificationService = void 0;
const core_1 = require("@angular/core");
const websocket_service_1 = require("./websocket.service");
const token_service_1 = require("./token.service");
const notifier_service_1 = require("./notifier.service");
const user_service_1 = require("./user.service");
const notification_service_1 = require("./notification.service");
const system_notification_1 = require("./system-notification");
const rxjs_1 = require("rxjs");
let SystemNotificationService = class SystemNotificationService {
    constructor(_webSocket, _http, _notifier, _currentUser, _talk) {
        this._webSocket = _webSocket;
        this._http = _http;
        this._notifier = _notifier;
        this._currentUser = _currentUser;
        this._talk = _talk;
        this.connected = false;
        this.notificationsCheckStarted = {
            systemnotification: false,
            lineitemautomationnotification: false,
            helmnotification: false
        };
        this.intervalId = null;
        this.notificationsUrl = '/notifications';
        this.notificationsRooms = ['systemnotification', 'lineitemautomationnotification', 'helmnotification'];
        this.pendingAutoclose = {};
        this.socketDisconnectCount = 0;
        this.helmSubject = new rxjs_1.BehaviorSubject(null);
        //Start interval timeout to check if the service can be initiated
        this.intervalId = setInterval(this.init.bind(this), 5000);
    }
    init() {
        if (this._http.verifySession()) { //if user is in session
            this.connect();
        }
    }
    connect() {
        if (!this.connected) {
            this._webSocket.connectSocket()
                .subscribe({
                next: this.onSocketConnectionEvent.bind(this)
            });
        }
    }
    loadNotifications() {
        this.notificationsRooms.forEach(roomName => {
            this.startPendingNotificationsCheck(roomName);
        });
        clearInterval(this.intervalId);
        this._notifier.emitter.subscribe(this.onClosedNotificationEvent.bind(this));
    }
    organizationSwitched() {
        this._notifier.switchOrganization();
        this.getNotifications()
            .then(response => response.json())
            .then(data => {
            let notifications = system_notification_1.SystemNotification.initCollection(data);
            this.logNotifications(notifications, 'systemnotification');
        });
    }
    /**
     * Sends initial Socket request and Subscribe observer to listen for changes on given room
     */
    startPendingNotificationsCheck(roomName) {
        if (!this.notificationsCheckStarted[roomName]) {
            this._webSocket.request({
                method: 'GET',
                url: `${this.notificationsUrl}/socket?notificationType=${roomName}&filterBy={"state":"display"}`,
                headers: this._http.createNewAuthHeaders()
            }).subscribe({
                next: (response) => {
                    this.notificationsCheckStarted[roomName] = true;
                    this.connected = true;
                    //log any initially found notifications
                    if (response.data) {
                        let notifications = system_notification_1.SystemNotification.initCollection(response.data);
                        this.logNotifications(notifications, roomName);
                        this.subscribePendingNotificationObserver(roomName);
                    }
                },
                error: (error) => {
                    console.error(`Error subscribing:${roomName} room notifications`, error);
                }
            });
        }
    }
    /**
     * Registers observer to get all changes events from given roomName;
     * And log received notifications
     */
    subscribePendingNotificationObserver(roomName) {
        this._webSocket.on(roomName + '-message').subscribe(function (event) {
            if (event.data) {
                let notifications = system_notification_1.SystemNotification.initCollection(event.data);
                this.logNotifications(notifications, roomName);
            }
        }.bind(this));
    }
    /**
     * Log received notifications to Notification service
     * @param {[{bidder: number; state: string; user: number}]} notifications
     */
    logNotifications(notifications, roomName) {
        if (notifications.length > 0) {
            let currentUser = this._currentUser.get();
            notifications.forEach((notification, idx) => {
                if (notification.isStateDisplay() || this.isLoadedNotification(notification, roomName)) {
                    if (roomName === 'lineitemautomationnotification' && notification.targetsCurrentUser(currentUser)) {
                        this.logLineItemNotification(notification, roomName);
                    }
                    else if (roomName === 'helmnotification' && notification.targetsCurrentUser(currentUser)) {
                        this.logHelmNotification(notification, roomName);
                        this.helmSubject.next(notification);
                    }
                    else if (notification.displayable(currentUser)) {
                        this.logSystemNotification(notification, roomName);
                    }
                }
            });
        }
    }
    logLineItemNotification(notification, roomName) {
        let notificationsParams = {
            id: this.getNotificationDisplayId(notification.bidder, roomName),
            title: 'Pending Line Item Automation',
            status: `BidderId ${notification.bidder} Pending DFP Verify`,
            type: 'warning',
            htmlContent: `<strong class="text-center">Note: The previously saved config settings will be used on verification.</strong>`,
            clickableContent: {
                handler: this.onPendingNotificationHandler(notification.bidder, roomName, notification.id),
                text: 'Continue DFP Verification'
            }
        };
        this._notifier.start(notificationsParams);
    }
    logHelmNotification(notification, roomName) {
        // TODO: determine position where to display
        let notificationsParams = {
            id: this.getNotificationDisplayId(notification.id, roomName),
            state: notification.state,
            title: notification.title || 'System Notification',
            message: notification.message || 'Unknown ',
            preserveType: notification.type,
            dbId: notification.id,
            deleteOnClose: true,
            roomName
        };
        this._notifier.start(notificationsParams);
        if (notification.type === 'temporary') {
            this.setAutoClose(notification, roomName);
        }
    }
    getAllNotifications() {
        return this._notifier.getAllNotifications();
    }
    deleteNotifier(id) {
        this._notifier.deleteNotification(id, true);
    }
    logSystemNotification(notification, roomName) {
        // TODO: determine position where to display
        let notificationsParams = {
            id: this.getNotificationDisplayId(notification.id, roomName),
            state: notification.state,
            title: notification.title || 'System Notification',
            message: notification.message || 'Unknown ',
            preserveType: notification.type,
            dbId: notification.id,
            deleteOnClose: (notification.type === 'temporary'),
            roomName
        };
        this._notifier.start(notificationsParams);
        if (notification.type === 'temporary') {
            this.setAutoClose(notification, roomName);
        }
    }
    /**
     * Create click which navigates to control center view, and then deletes the clicked notification
     * @returns {any}
     */
    onPendingNotificationHandler(bidder, roomName, notificationId) {
        return function () {
            this._router.navigate(['controlcenter/edit', bidder], { queryParams: { retryLiaVerify: true } })
                .then(nav => {
                if (nav) { //if user navigated successfully
                    //We can safely delete this bidder notification
                    return this.deleteNotification(notificationId, roomName);
                }
                this._talk.broadcast(`<p>Oops! we are unable to continue DFP Verification for this bidder. The bidder config settings may not longer be available.</p>`);
            });
        }.bind(this);
    }
    /**
     * Get all saved notifications
     */
    getNotifications(roomName = 'systemnotification', filterBy) {
        let url = `${this.notificationsUrl}?notificationType=${roomName}`;
        if (filterBy)
            url += `&filterBy=${filterBy}`;
        return this._http.get(url).toPromise();
    }
    /**
     * Submit request to Delete a notification from given room
     */
    deleteNotification(id, roomName, stopPermanentNotification = true) {
        return this._http.delete(`${this.notificationsUrl}?notificationType=${roomName}&filterBy={"id":${id}}`)
            .toPromise()
            .then((response) => {
            console.log(`DELETED Pending ${roomName} Notification:${id}`, response);
            this._notifier.deleteNotification(this.getNotificationDisplayId(id, roomName), stopPermanentNotification);
            this.postDeletedNotificationLog(response.json()[0], roomName);
            return response.json();
        })
            .catch((err) => {
            console.error(`Unable to delete ${roomName} pending notification ${id}`, err.message);
            return err;
        });
    }
    /**
     * Log a deleted notification to change log
     */
    postDeletedNotificationLog(deletedNotification, roomName) {
        if (deletedNotification) {
            this._http.post('/notificationschangelog', {
                bidder: deletedNotification.bidder || null,
                lastState: deletedNotification.state,
                deletedBy: deletedNotification.user || null,
                org: deletedNotification.org || null,
                roomName
            })
                .toPromise()
                .then(response => console.log('Deleted Notification Log posted'))
                .catch(err => console.error('Unable to submit deleted notification log', err));
        }
    }
    createNotification(notification, roomName = 'systemnotification') {
        return this._http.post(`${this.notificationsUrl}?notificationType=${roomName}`, notification).toPromise();
    }
    setAutoClose(notification, roomName) {
        if (notification.endTime) {
            // determine if we should set time to auto close/delete this notification
            let startTime = (notification.startTime) ? moment(notification.startTime) : moment();
            let endTime = moment(notification.endTime);
            if (startTime.month() === endTime.month() && startTime.day() === endTime.day()) {
                let closeMs = endTime.diff(startTime, 'ms');
                console.log('closing notification in', closeMs);
                if (closeMs > 0) {
                    this.pendingAutoclose[this.getNotificationDisplayId(notification.id, roomName)] = setTimeout(() => {
                        console.log('delete notification', notification.id);
                        this._notifier.deleteNotification(this.getNotificationDisplayId(notification.id, roomName));
                        this.deleteNotification(notification.id, roomName);
                        delete this.pendingAutoclose[this.getNotificationDisplayId(notification.id, roomName)];
                    }, closeMs);
                }
            }
        }
    }
    stopAutoClose(notificationId, roomName) {
        if (!!this.pendingAutoclose[this.getNotificationDisplayId(notificationId, roomName)]) {
            clearTimeout(this.pendingAutoclose[this.getNotificationDisplayId(notificationId, roomName)]);
        }
    }
    getNotificationDisplayId(notificationId, additionalText) {
        return `${(additionalText || 'notification')}:${notificationId}`;
    }
    isLoadedNotification(notification, roomName = 'systemnotification') {
        return (notification.id && roomName && this._notifier.findNotificationIdx(this.getNotificationDisplayId(notification.id, roomName)) !== -1);
    }
    /**
     * Reveices events from notifier to delete closed notifications from DB
     */
    onClosedNotificationEvent(event) {
        if (event.command === 'delete' && event.notification && event.notification.deleteOnClose && event.notification.dbId && event.notification.roomName) {
            this.stopAutoClose(event.notification.dbId, event.notification.roomName);
            this.deleteNotification(event.notification.dbId, event.notification.roomName, false);
        }
    }
    onSocketConnectionEvent(event) {
        this.connected = !!event.connected;
        if (event.connected) {
            if (this.socketDisconnectCount > 0)
                this.socketDisconnectCount = 0;
            // reload notifications so the socket gets reconnected
            this.loadNotifications();
        }
        else {
            this.socketDisconnectCount++;
            if (this.socketDisconnectCount <= 1) {
                // reset any notifications checks;
                for (let k in this.notificationsCheckStarted) {
                    this.notificationsCheckStarted[k] = false;
                }
            }
        }
    }
};
exports.SystemNotificationService = SystemNotificationService;
exports.SystemNotificationService = SystemNotificationService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [websocket_service_1.WebSocketService,
        token_service_1.TokenService,
        notifier_service_1.NotifierService,
        user_service_1.UserService,
        notification_service_1.NotificationService])
], SystemNotificationService);
//# sourceMappingURL=system-notification.service.js.map